import * as React from "react";
import {useRef, useState} from "react";
import {
    ClearAll,
    Filters,
    FiltersSelected,
    Search,
    SortBy as ReactifySortBy,
    Stats,
    useSearch
} from "@usereactify/search";
import SearchResultsStats from "../Search/SearchResultsStats";
import ModelViewToggle from "@src/stories/client/ModelViewToggle/ModelViewToggle";
import {SortBy} from "@project-stories/client/SortBy/SortBy";
import {ClearAll as ReactifyClearAll} from "@usereactify/search/dist/src/components/ClearAll/ClearAll";
import useAnimationEnd from "@mindarc/arctheme-components/frontend/src/hooks/useAnimationEnd";

export const CollectionBar = ({ settings, isMobile }) => {
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const [isAnimatingSidebar, setIsAnimatingSidebar] = useState(false);
    const slidingDivRef: any = useRef(false);

    const useProvider = true;
    const toggleSidebar = () => {
        setSidebarVisible(!isSidebarVisible);
        setIsAnimatingSidebar(true);
    };
    useAnimationEnd(slidingDivRef, () => {
        if (!isSidebarVisible) {
            console.log('Animation END - CLOSE');
        } else {
            console.log('Animation END - OPEN');
        }
        setIsAnimatingSidebar(false);
    });


    React.useEffect(() => {

        const handleEscapeKey = (event) => {
            if (event.key === "Escape") {
                setSidebarVisible(false);
            }
        };
        window.dispatchEvent(new CustomEvent("collection-search-loaded"));
        window.addEventListener("keydown", handleEscapeKey);

        // Cleanup the event listeners on component unmount
        return () => {
            // window.removeEventListener("product-list", handleProductsResults);
            // window.removeEventListener("filter-list", handleFiltersResults);
            // window.removeEventListener("keydown", handleEscapeKey);
        };
    }, []);
    const searchHook = useSearch();

    return (
        <div className={`flex gap-[20px] w-full`}>
            <div className={`product-results ${isMobile ? 'flex-col' : 'flex-row'}`}>

                <div ref={slidingDivRef} className={`${isSidebarVisible ? 'product-results__filters-container fixed slide-in-from-right' : `hidden ${isAnimatingSidebar && `slide-out-to-right`}`} 
                top-[50px] lg:top-[0px] right-0 fixed z-[10] lg:w-[400px] bg-white p-[32px] pt-[100px] lg:pt-[180px] h-full gap-[16px]`}>
                    <div className={'flex h4 justify-end gap-x-[8px] mb-[32px]'} onClick={() => toggleSidebar()}>
                    CLOSE FILTER <span className={`h4`}><i className={`icon icon-close text-[12px]`} /> </span>
                    </div>

                    <div className={`product-results__filters bg-white`}>
                    <div className={'filters_data flex items-center gap-[16px]'}>
                        <FiltersSelected />
                        <ReactifyClearAll render={ClearAll}/>
                    </div>


                    <Filters showEmptyFilters={true}  />
                    </div>
                </div>

                <div className={`flex flex-col gap-[20px] w-full`}>
                    <div className={`flex gap-[20px] w-full pb-[32px] pt-[40px]`}>
                        <div className={`product-results ${isMobile ? 'flex-col' : 'flex-row'}`}>
                            <div className={`product-results__modelview`}>
                                <ModelViewToggle />
                            </div>
                            <h2 className={`product-results__summary h3`}>
                                DISCOVER {settings.collection.title}
                            </h2>
                            <div className={`product-results__toolbar`}>
                                <div className={'product-results__toolbar-sort h5'}>
                                    <ReactifySortBy render={(props) => <SortBy {...props} />} />
                                </div>
                                <div className={'product-results__toolbar-filter h5'}
                                    onClick={() => toggleSidebar()}>
                                    FILTERS
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollectionBar;
